import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function SubscriptionOverview() {
  const benefits = ['Daily 2–5 odds tickets', 'Exclusive insider access', 'Reliable predictions', '24/7 support team', 'Steady profit focus'];
  return <section className="bg-green-100 rounded-xl shadow-md p-6" data-id="element-138">
      <div className="text-center mb-6" data-id="element-139">
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-140">
          GreenHS VIP – 30 Days Access
        </h2>
        <p className="text-gray-700" data-id="element-141">
          Daily accurate 2–5 odds ticket posted directly to the VIP channel!
        </p>
      </div>
      <div className="space-y-3" data-id="element-142">
        {benefits.map((benefit, index) => <div key={index} className="flex items-center" data-id="element-143">
            <CheckCircle2Icon className="h-5 w-5 text-green-600 mr-3 flex-shrink-0" data-id="element-144" />
            <span className="text-gray-800" data-id="element-145">{benefit}</span>
          </div>)}
      </div>
    </section>;
}